module.exports = __webpack_public_path__ + "img/goldregen-2020-080.082393b6.jpg";